import { render } from "./DeveloperSideNav.vue?vue&type=template&id=03788d52"
import script from "./DeveloperSideNav.vue?vue&type=script&lang=js"
export * from "./DeveloperSideNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__